
import React from 'react';
import { NewsletterForm } from '@/components/home/NewsletterForm';
import { Toaster } from 'sonner';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Mail } from 'lucide-react';

const Newsletter = () => {
  const handleSuccess = () => {
    console.log('Newsletter subscription successful');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-xl mx-auto">
            <NewsletterForm 
              onSuccess={handleSuccess} 
              standalone={true} 
              isModal={true}
            />
          </div>
        </div>
      </main>
      <Footer />
      <Toaster position="top-center" />
    </div>
  );
};

export default Newsletter;
